// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__PvU-r","noBorder":"Admin_noBorder__qUgEg","block":"Admin_block__RkWi-","filterContainer":"Admin_filterContainer__qiL7A"};